import {toast} from 'react-toastify';

let initialState = {
	infos: [],
	one: [],
	create: [],
	update: []
};

const getLaureatsInfos = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_LAUREATSTREMPLIN_RETURN':
			return Object.assign({}, state, {infos: action.payload});

		case 'POST_LAUREAT_RETURN':
			const arrayData = [action.payload.data];
			let newStateAdd;
			if (action.payload.status === 201) {
				newStateAdd = {...state.infos, data: state.infos.data.concat(arrayData)};
				const notifySuccess = () =>
					toast.success('Lauréat ajouté !', {
						position: 'top-right',
						autoClose: 2000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifySuccess();
			} else {
				newStateAdd = state.infos;
				if (action.payload.status === 400) {
					const notifyError = () =>
						toast.error('Erreur !', {
							position: 'top-right',
							autoClose: 3000,
							hideProgressBar: false,
							closeOnClick: true,
							pauseOnHover: true,
							draggable: true,
							progress: undefined
						});
					notifyError();
				}
				if (action.payload.status === 409) {
					const notifyError = () =>
						toast.error('Erreur, la position est prise !', {
							position: 'top-right',
							autoClose: 3000,
							hideProgressBar: false,
							closeOnClick: true,
							pauseOnHover: true,
							draggable: true,
							progress: undefined
						});
					notifyError();
				}
			}
			return Object.assign({}, state, {
				create: action.payload,
				infos: newStateAdd
			});

		case 'DEL_LAUREAT_SAGAS':
			const laureats = state.infos.data;
			const indexLaureat = laureats.findIndex((index) => index.uuid === action.payload);
			const newStateDelete = {...state.infos, data: laureats.filter((item, i) => i !== indexLaureat)};
			return Object.assign({}, state, {infos: newStateDelete});

		case 'DEL_LAUREAT_RETURN':
			if (action.payload.status === 202) {
				const notifySuccess = () =>
					toast.success('Lauréat supprimé !', {
						position: 'top-right',
						autoClose: 2000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifySuccess();
			} else {
				const notifyError = () =>
					toast.error('Erreur ! merci de le signaler...', {
						position: 'top-right',
						autoClose: 3000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifyError();
			}
			return Object.assign({}, state, {delete: action.payload});

		default:
			return state;
	}
};

export default getLaureatsInfos;
